<section id="section1">
  <div class="container_popup_guiasweb" id="popop_guiasweb_movil" style="display: none;">
      <div id="btn_close" title="cerrar" (click)="closeBtnpopupguiasmovil($event)">x</div>

      <div class="promo-slider" id="slider_popop_guiasweb_movil">

       <div id="carouselGuiasWebMovil" class="carousel slide" data-ride="carousel">
         <ol class="carousel-indicators">
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="0" class="active"></li>
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="1"></li>
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="2"></li>
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="3"></li>
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="4"></li>
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="5"></li>
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="6"></li>
           <li data-target="#carouselGuiasWebMovil"  data-slide-to="7"></li>
           
         </ol>
         <div class="carousel-inner ">
            <!-- POPUP MOVIL SLIDER 1 -->
          

            <div class="carousel-item active">
               <div class="container-movilpopguiasweb"  routerLink="/promocion" id="slider_item_guiasweb_movil">
                  <div style="display: flex;">
                     <img class="img-popupguiasweb" src="assets/img/redActiva/logo_redActiva_white.webp" id="img_mini">
                     <div class="container-data-popguiasweb" style="margin-left: 20px;">
                        <p class="txt-popupguiasweb" style="font-size: 10px;line-height: 14px;">Llegamos a más ciudades para ti</p>
                        <p class="txt-popupguiasweb" style="font-size: 9px;line-height: 15px;margin-top: 5px;">Cotiza tus envíos a más ciudades de México y ¡Llega a más destinos!</p>
                     </div>
                  </div>
                  <div class="container-data-popguiasweb" style="align-items: center; margin-right: 10px;">
                   <button id="btn_canjear_promo_movil" class="btn-obtener-movil" style="font-size: 10px;line-height: 15px;padding: 10px;"  routerLink="/red-activa">Cotizar</button>
                  </div>
               </div>
            </div>
            
              <!-- POPUP MOVIL SLIDER 2 -->
           <div class="carousel-item">
            <div class="container-movilpopguiasweb"  routerLink="/promocion" id="slider_item_guiasweb_movil">
               <div style="display: flex;">
                  <img class="img-popupguiasweb" src="assets/img/beneficios/IMGS-PROMOCION/promoPopupHermosillo.webp" id="img_mini">
                  <div class="container-data-popguiasweb" style="margin-left: 20px;">
                     <p class="txt-popupguiasweb" style="font-size: 10px;line-height: 14px;">¡Atención, Hermosillo!</p>
                     <p class="txt-popupguiasweb" style="font-size: 9px;line-height: 15px;margin-top: 5px;">TUFESAPACK tiene una promo que te hará gritar de emoción.</p>
                  </div>
               </div>
               <div class="container-data-popguiasweb" style="align-items: center; margin-right: 10px;">
                <button id="btn_canjear_promo_movil" class="btn-obtener-movil" style="font-size: 10px;line-height: 15px;padding: 10px;"  routerLink="/promocion" [queryParams]="{ code: 'promohermosillo'}">¡Clic aquí!</button>
               </div>
            </div>
         </div>
       
            <!-- POPUP MOVIL SLIDER 3 -->
             <div class="carousel-item ">
              <div class="container-movilpopguiasweb">
                <div style="display: flex;">
                   <img class="img-popupguiasweb" style="width: 60px;margin-left: 8px;background: #fff;border-radius: 20px;padding: 5px;" src="assets/img/beneficios/PAKTCAMBIES/PaktCambies_popup.png" id="img_mini">
                   <div class="container-data-popguiasweb" style="margin-left: 20px;">
                      <p class="txt-popupguiasweb" style="font-size: 11px;">¡Es hora de un cambio!</p>
                   </div>
                </div>
                <div class="container-data-popguiasweb" style="align-items: center; margin-left: 9px;">
                  <button id="btn_canjear_promo_movil" class="btn-obtener-movil" style="font-size: 10px;"  routerLink="/PaKTCambies"  [queryParams]="{ code: 'PROMOPKTCAM25'}">¡Cámbiate aquí!</button>
                </div>
             </div>
            </div>

            <!-- POPUP MOVIL SLIDER 4 -->
            
            <div class="carousel-item">
              <div class="container-movilpopguiasweb" id="slider_item_guiasweb_movil">
                 <div style="display: flex;">
                    <img class="img-popupguiasweb" src="assets/img/promociones/tfpckhora_popup.png" id="img_mini" style="margin-left: 10px; width: 55px; height: 57px; margin-top: 6px">
                    <div class="container-data-popguiasweb" style="margin-left: 20px;">
                       <p class="txt-popupguiasweb" style="font-size: 10px;">Envía y recibe el mismo día</p>
                       <p class="txt-popupguiasweb" style="font-size: 7px; line-height: 1.5; font-size: 9px; width: 90%;">Nuevo Servicio ¡TufesaPack Horas!</p>
                    </div>
                 </div>
                 <div class="container-data-popguiasweb" style="align-items: center; margin-left: 9px;">
                  <button id="btn_obtener_promo_tepmxl_movil" class="btn-obtener-movil" style="font-size: 10px;" routerLink="/tufesapack-horas">¡Conócelo!</button>
                </div>
              </div>
           </div>
           <!-- POPUP MOVIL SLIDER 5 -->
           <div class="carousel-item">
            <div class="container-movilpopguiasweb">
              <div style="display: flex;">
                 <img class="img-popupguiasweb" style="width: 60px;height: 60px; margin-left: 8px;" src="assets/img/beneficios/PAKGANES/popup_pakganes.png" id="img_mini">
                 <div class="container-data-popguiasweb" style="margin-left: 20px;">
                    <p class="txt-popupguiasweb" style="font-size: 11px;">¡Invita y Gana!</p>
                    <p class="txt-popupguiasweb" style="font-size: 10px;line-height: 15px;">Recomienda nuestro servicio y obtén beneficios.</p>
                 </div>
              </div>
              <div class="container-data-popguiasweb" style="align-items: center; margin-left: 9px;">
                <button id="btn_canjear_promo_movil" class="btn-obtener-movil" style="font-size: 10px;line-height: 15px;"  routerLink="/PaKGanes">¡Quiero invitar!</button>
              </div>
           </div>
          </div>

          

           <!-- POPUP MOVIL SLIDER 6 -->
           <div class="carousel-item">
             <div class="container-movilpopguiasweb">
               <div style="display: flex;">
                  <img class="img-popupguiasweb" style="width: 56px; margin-left: 8px;" src="assets/img/popupslider3.png" id="img_mini">
                  <div class="container-data-popguiasweb" style="margin-left: 20px;">
                     <p class="txt-popupguiasweb" style="font-size: 11px;">¿Tienes código promocional?</p>
                     <p class="txt-popupguiasweb" style="font-size: 10px;">¡CANJEALO AQUÍ!</p>
                  </div>
               </div>
               <div class="container-data-popguiasweb" style="align-items: center; margin-left: 9px;">
                 <button id="btn_canjear_promo_movil" class="btn-obtener-movil" style="font-size: 10px;"  routerLink="/herramientasDigitales/documentacion/menu">Obtener</button>
               </div>
            </div>
           </div>

         </div>
         <a class="carousel-control-prev" href="#carouselGuiasWebMovil"  role="button" data-slide="prev">
           <span class="carousel-control-prev-icon" aria-hidden="true"></span>
           <span class="sr-only">Previous</span>
         </a>
         <a class="carousel-control-next" href="#carouselGuiasWebMovil"  role="button" data-slide="next">
           <span class="carousel-control-next-icon" aria-hidden="true"></span>
           <span class="sr-only">Next</span>
         </a>
       </div>
     </div>
   </div>

   <!-- fin contenedor principal de banners popup mobil -->

   <!-- Banners contenedor principal banners deskop y laptop -->
  <div #slideGuiasWeb class="container_newslide" id="slide_guiasweb">
     <div id="btn_close" title="cerrar" style="background-color: black; color: white;" (click)="closeBtnGuiaslide()">x</div>
     <div class="promo-slider" id="slide_guiasweb_desktop">

       <div id="carouselGuiasWeb" class="carousel carousel-dark slide" data-ride="carousel">
         <ol class="carousel-indicators">
            <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="0" class="active"></li>
            <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="1"></li>
            <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="2"></li>
            <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="3"></li>
            <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="4"></li>
            <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="5"></li>
            <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="6"></li>
            <!-- <li data-target="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" data-slide-to="7"></li> -->

         </ol>
         <div class="carousel-inner">
                    <div class="carousel-item active">
            <div class="cont-txtguiasweb" style="display: flex; flex-direction: column; align-items: center;">
                <label style="font-size: 17px; font-weight: 900;text-align: center;">Envíos del Amor y la Amistad</label>
                 <label style="font-weight: 900; font-size: 14px;text-align: center; margin-top: 15px;"> Compra guías WEB y recibe hasta ¡50 guías adicionales!</label>
                <img class="" src="assets/img/beneficios/img_promo_enviosAmor.webp" id="" style=" width: 165px;
                margin-top: 5px;">
                <div class="section-info-guias-web" style="text-align: center; margin-top: 0px;">
                  <label style="font-size: 12px; font-weight: bold;">Solo clientes nuevos <br> <span style="font-size: 11px;font-weight: 100;">Vigencia del 09 al 13 de febrero de 2026.</span></label>
                </div>
                <button class="btn-comprarguiasslide" routerLink="/promocion" style="margin-top: 9px;" [queryParams]="{ code: 'envios-que-enamoran'}">¡Más información!</button>
            </div>
          </div>

          <div class="carousel-item">
            <div class="cont-txtguiasweb" style="display: flex; flex-direction: column; align-items: center;">
                <label style="font-size: 17px; font-weight: 900;text-align: center;">Manda y Gana con TUFESAPACK</label>
                 <label style="font-weight: 900; font-size: 14px;text-align: center;">Envía a domicilio y gana ¡Un viaje a Mazatlán!</label>
                <img class="" src="assets/img/beneficios/img_promoMandayGana.webp" id="" style=" width: 165px;
                margin-top: 20px;">
                <div class="section-info-guias-web" style="text-align: center;">
                  <label style="font-size: 12px;">Participa en el giveaway <br><b style="font-size: 12px;">#MandaYGanaConTUFESAPACK</b></label>
                </div>
                <button class="btn-comprarguiasslide" routerLink="/promocion" style="margin-top: 9px;" [queryParams]="{ code: 'manda-y-gana'}">¡Consulta las bases!</button>
            </div>
          </div>

            <!-- POPUP SLIDER 1 -->
              <div class="carousel-item ">
            <div class="cont-txtguiasweb">
              <label style="font-size: 17px;text-align: center;padding: 5px 10px;margin-top: 20px;"><b>Llegamos a más ciudades para ti</b></label>
              <img class="" src="assets/img/redActiva/logo_redActiva_min.webp" id="" style=" width: 160px; margin-top: 80px; margin-bottom: 5px;">
              <div class="section-info-guias-web" style="text-align: left; font-size: 12px; background-color: unset; padding: 0px 15px; margin-bottom: 0px; width: auto;">
                   <p style="margin-bottom: 0px; margin-top: 0px;line-height: 16px;text-align: center;padding: 0px 15px; font-weight: bold;">Cotiza tus envíos a más ciudades de México y ¡Llega a más destinos!</p>
              </div>
              <button id="btn_slider_conjear_codigopromo" class="btn-comprarguiasslide" routerLink="/red-activa" style="margin-top: 68px;">¡Cotiza aquí!</button>
            </div>
          </div>

          <!-- POPUP SLIDER 2 -->
          <div class="carousel-item">
            <div class="cont-txtguiasweb">
              <label style="font-weight: 900; font-size: 16px;text-align: center;padding: 15px 10px;">¡Atención, Hermosillo!</label>
              <img class="" src="assets/img/beneficios/IMGS-PROMOCION/promoPopupHermosillo.webp" id="" style=" width: 148px; margin-top: 28px;">
              <div class="section-info-guias-web" style="text-align: center; font-size: 11px; background-color: unset; padding-top: 0px; margin-bottom: 0px;">
                   <p style="margin-bottom: 0px; margin-top: 0px;line-height: 16px;">TUFESAPACK tiene una promo que te hará gritar de emoción
                   </p>
              </div>
              <button id="btn_slider_conjear_codigopromo" class="btn-comprarguiasslide" routerLink="/promocion" style="margin-top: 77px;" [queryParams]="{ code: 'promohermosillo'}">Haz clic aquí</button>
            </div>
          </div>

          <!-- POPUP SLIDER 3 -->
            <div class="carousel-item ">
              <div class="cont-txtguiasweb">
                <label style="font-weight: 900; font-size: 16px;">¡Es hora de un cambio!</label>
                <img class="" src="assets/img/beneficios/PAKTCAMBIES/PaktCambies_popup.png" id="" style=" width: 185px; margin-top: 28px;">
                <div class="section-info-guias-web" style="text-align: center; font-size: 12px; background-color: unset; margin-top: 10; padding-top: 0px; margin-bottom: 0px;">
                     <p style="margin-bottom: 0px; margin-top: 60px;">Optimiza tus envíos y obtén beneficios exclusivos para ti.</p>
                </div>
                <button id="btn_slider_conjear_codigopromo" class="btn-comprarguiasslide" routerLink="/PaKTCambies" style="margin-top: 39px;" [queryParams]="{ code: 'PROMOPKTCAM25'}">¡Cámbiate aquí!</button>
              </div>
            </div>

            <!-- POPUP SLIDER 4 -->
           <div class="carousel-item ">
            <div class="cont-txtguiasweb">
               <label style="font-weight: 900; font-size: 16px; margin-top: 0px; text-align: center; width: 159px; line-height: 1.5;">Envía y recibe el mismo día</label>
               <img class="" src="assets/img/promociones/tfpckhora_popup.png" id="" style=" width: 150px; margin-top: 30px; margin-left: 10px; margin-bottom: 20px;">
               <div class="section-info-guias-web" style="margin-top: 0px; padding-top: 0px;">
                    <label style="text-align: center; font-size: 12px; width: 178px; margin-bottom: 0px; width: 210px; line-height: 1.8;">Nuevo Servicio ¡TufesaPack Horas!</label>
               </div>
               <button id="btn_slider_comprar_guiasweb" class="btn-comprarguiasslide"  style="margin-top: 80px; font-size: 12px;" routerLink="/tufesapack-horas"> ¡Conócelo!</button>
            </div>
          </div>

             <!-- POPUP SLIDER 5 -->
            <div class="carousel-item">
              <div class="cont-txtguiasweb">
                <label style="font-size: 16px; font-weight: 900;">¡Invita y Gana!</label>
                <img class="" src="assets/img/beneficios/PAKGANES/popup_pakganes.png" id="" style=" width: 148px; margin-top: 28px;">
           
                <div class="section-info-guias-web" style="text-align: center; font-size: 12px; background-color: unset; margin-top: 10; padding-top: 0px; margin-bottom: 0px;">
                     <p style="margin-bottom: 0px; margin-top: 27px;">Recomienda nuestro servicio y obtén beneficios.</p>
                </div>
                <button id="btn_slider_conjear_codigopromo" class="btn-comprarguiasslide" routerLink="/PaKGanes" style="margin-top: 68px;">¡Quiero Invitar!</button>
              </div>
            </div>
          

         <!-- POPUP SLIDER 6 -->
           <div class="carousel-item">
             <div class="cont-txtguiasweb">
               <label style="font-weight: 900; font-size: 12px;">¿Tienes código promocional?</label>
               <label style="font-size: 18px; font-weight: 900;">¡CANJEALO AQUÍ!</label>
               <img class="" src="assets/img/popupslider3.png" id="" style=" width: 148px; margin-top: 28px;">
               <div class="section-info-guias-web" style="text-align: center; font-size: 12px; background-color: unset; margin-top: 10; padding-top: 0px; margin-bottom: 0px;">
                    <p style="margin-bottom: 0px; margin-top: 27px;">¡Obtén grandes descuentos canjeando tu código promocional aquí!</p>
               </div>
               <button id="btn_slider_conjear_codigopromo" class="btn-comprarguiasslide" routerLink="/herramientasDigitales/documentacion/menu" style="margin-top: 39px;">Canjear</button>
             </div>
           </div>

         </div>

         <a class="carousel-control-prev" href="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" role="button" data-slide="prev">
           <span class="carousel-control-prev-icon" aria-hidden="true"></span>
           <span class="sr-only">Previous</span>
         </a>
         <a class="carousel-control-next" href="#carouselGuiasWeb" data-bs-target="#carouselExampleDark" role="button" data-slide="next">
           <span class="carousel-control-next-icon" aria-hidden="true"></span>
           <span class="sr-only">Next</span>
         </a>
       </div>

     </div>
     <!-- <div class="cont-txtguiasweb" style="display: flex; flex-direction: column; align-items: center;">
        <label style="font-weight: 900; font-size: 16px;">Adquiere tus</label>
        <label style="font-size: 25px; font-weight: 900;">Guias web</label>
        <img class="" src="assets/iconos/info-util/icon_tipsSeg.webp" id="" style=" width: 148px;
        margin-top: 20px;">
        <div class="section-info-guias-web">
           <label style="color: white;">Desde</label>
           <label style="color: white; font-size: 30px; font-weight: 700; margin: 6px 0px 18px 0px">$750</label>
           <label style="color: white; font-size: 10px; margin-bottom: 0px;">Comprar guias digitales</label>
           <label style="color: white; font-size: 10px;">Consulte restricciones</label>
        </div>
        <button class="btn-comprarguiasslide" routerLink="/guias-web">Comprar</button>
     </div> -->
  </div>

  <!-- Mensaje Gris modificado a naranja -->
  <!-- <div class="container_slide" id="cont_slide">
     <div id="btn_close" title="cerrar" (click)="closeBtnslide()">x</div>
     <img class="img_mini_slide" src="assets/iconos/logo_tp_mini.webp" id="img_mini_slide">
      <a routerLink="/tupromo"  [queryParams]="{ code: 'TPZ50' }">
         <div class="btn_get">Canjear</div>
     </a> -->
     <!-- <a routerLink="/herramientasDigitales/documentacion/menu">
       <div class="btn_get">Canjear</div>
    </a>
     <div class="cont-txt" id="cont_txt_slide">
         <h1 class="txt_tittle">¿Tienes un código promocional?</h1>
         <p class="txt_promo">¡ Canjealo aquí !</p>
     </div>
  </div>  -->
  <!-- Fin Mensaje Gris modificado a naranja -->

  <!-- Mensaje Gris sin modificar -->
  <!-- <div class="container_slide" id="cont_slide">
      <div id="btn_close" title="cerrar" (click)="closeBtnslide()">x</div>
      <img class="img_mini_slide" src="assets/iconos/hero/promociones.png" id="img_mini_slide">
      <a routerLink="/tupromo"  [queryParams]="{ code: 'TPZ50' }">
       <div class="btn_get">Obtener</div>
      </a>
      <div class="cont-txt" id="cont_txt_slide">
         <h1 class="txt_tittle">¡Estamos en Zapopan! </h1>
         <p class="txt_promo">Obtén tu primer envío con <br> un 50 % de descuento </p>
     </div>
   </div> -->
   <!-- Fin Mensaje Gris sin modificar -->
 <app-herramientas-menu></app-herramientas-menu>
</section>
 <section id="section2" style="padding-top: 0px;">
   <app-servicios></app-servicios>
   <a href="#section3">
       <div class="arrow forPromo">
           <span></span>
           <span></span>
           <span></span>
       </div>
   </a>
  </section>
  <section id="beneficios">
    <app-tufesapack-beneficios></app-tufesapack-beneficios>
    <!-- <a href="#section3">
        <div class="arrow">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </a> -->
   </section>
  <section id="section3">
   <app-about-us></app-about-us>
   <a href="#section4">
       <div class="arrow">
           <span></span>
           <span></span>
           <span></span>
       </div>
   </a>
  </section>
<section id="section4">
 <app-informacion-util></app-informacion-util>
 <app-punto-envio></app-punto-envio>
</section>

